import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { Event } from '@interfaces';
import { AppService } from '../../../../../../services';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, app: AppService): GridSetup<Event> {

	return {
		rowName: { singular: 'Past Event', plural: 'Past Events' },
		getRowKey: row => '' + row.eventId,
		stateKey: 'delivery-past-events-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util, app),
	}
}
